import { StateCreator } from 'zustand';

type AppStore = {
  loaded: boolean;
  setLoaded: (loaded: boolean) => void;
};

export const createAppState: StateCreator<AppStore> = (set) => ({
  loaded: false,
  setLoaded: (loaded: boolean): void => set({ loaded }),
});
